import Cookies from 'js-cookie';

/**
 * [mutations]
 * Guardar o token nas cookies
 *
 * @param {Object} token
 * @since 1.0.0
 * @category mutations
 * @author Tiago Martinho
 *
 */
const SAVE_TOKEN = ( state, token ) => {
    state.token = token;
    Cookies.set( 'token', token, { expires: 365 });
};

/**
 * [mutations]
 * Regista o utilizador na store user.
 *
 * @param {Object} user
 * @since 1.0.0
 * @category mutations
 * @author Tiago Martinho
 *
 */
const REGIST_USER = ( state, user ) => {
    state.user = {
        ...state.user,
        ...user
    };

    state.error = false;

    Cookies.set( 'currentUser', true, { expires: 365 });
};

/**
 * [mutations]
 * Executa o logout do software, no qual irá apagar o utilizador da store
 * e as cookies guaradas.
 *
 * @since 1.0.0
 * @category mutations
 * @author Tiago Martinho
 *
 */
const LOGOUT = state => {
    state.user = {};
    state.error = false;
    state.token = null;
    Cookies.remove( 'token' );
    Cookies.remove( 'currentUser' );
};

export default {
    SAVE_TOKEN,
    REGIST_USER,
    LOGOUT
};